import React from 'react'
import { Progress } from 'reactstrap'
import { FilterBlack, SwapVer } from '../../../assets/images'
import Select from 'react-select'
import '../Styles/index.scss'
import { SearchIcon } from '../../Icon'
import GstDateSelect from '../../commons/Gst/GstDateSelect'
import { FilterType, GstRadioTypes } from '../../../commonTypes/gstTypes'
import OutWardsFilter from '../../commons/Gst/gstFilter/OutwardsFilter'
import GstSorting from '../../commons/Gst/gstFilter/GstSorting'
import { RadioTypes } from '../../../commonTypes/universalTypes'
import DownloadGstrReports from '../DownloadGstrReports/DownloadGstrReports'

type AppProps={
    clientCode: number;
    token: string | null;
    companyName: string;
    filters:FilterType;
    setFilters:(data:FilterType)=>void;
    filtersValue:FilterType;
    setMultiSelectData:(data:any)=>void;
    setFiltersValue:(data:FilterType)=>void;
    text:string;
    totalOutwardsListCount:number;
    handleSetIcon:()=>any;
    totalInvoiceValue:number;
    handleSearch:(data:any)=>void;
    setToggle:(data:boolean)=>void;
    toggle:boolean;
    currentYear:number;
    startDate:string;
    multiSelectData:any;
    endDate:string;
    sorting:GstRadioTypes | undefined;
    handleStartDateChange:(data:any)=>void;
    handleEndDateChange:(data:any)=>void;
    setSorting:(data:RadioTypes | undefined)=>void;
    setOffset:(data:number)=>void;
    resetData:()=>void;
    applyDate:(start:string,end:string)=>void;
}

const OutwardHeader = ({totalOutwardsListCount,
                        clientCode,
                        token,
                        companyName,
                        currentYear,
                        handleSetIcon,
                        totalInvoiceValue,
                        handleSearch,
                        text,
                        setToggle,
                        toggle,
                        startDate,
                        endDate,
                        filters,
                        sorting,
                        setSorting,
                        setFilters,
                        filtersValue,
                        setFiltersValue,
                        handleStartDateChange,
                        handleEndDateChange,
                        setMultiSelectData,
                        multiSelectData,
                        setOffset,
                        resetData,
                        applyDate
                    }:AppProps) => {
  
    return (
        <>
            <div className="top-most-div">

                <div>
                    <div className='header'>Outward Supplies</div>
                    <div className="below-header mt-1">Total {totalOutwardsListCount? totalOutwardsListCount : 0} entries found</div>
                </div>

                <div className='search-select-div'>

                    <div className="position-relative" style={{ width: "180px" }}>
                        <span style={{ position: "absolute", top: "8px", left: "18px" }}>
                            <SearchIcon />
                        </span>
                        <input
                            className="form-control"
                            type="text"
                            placeholder="Search"
                            onChange={(e: any) => handleSearch(e)}
                            style={{ paddingLeft: "35px", marginRight: "-50px" }}
                            value={text}
                        />
                    </div>

                    <div>
                        <GstDateSelect
                            setToggle={setToggle}
                            toggle={toggle}
                            startDate={startDate}
                            endDate={endDate}
                            handleStartDateChange={handleStartDateChange}
                            handleEndDateChange={handleEndDateChange}
                            applyDate={applyDate}
                            setOffset={setOffset}
                            resetData={resetData}
                        />
                     
                    </div>
                 
                    <div className='mar-auto-bg-white'>
                       <OutWardsFilter
                       type={"outwards"}
                       filters={filters}
                       setFilters={setFilters}
                       multiSelectData={multiSelectData}
                       filtersValue={filtersValue}
                       setFiltersValue={setFiltersValue}
                       setMultiSelectData={setMultiSelectData}
                       setOffset={setOffset}
                       resetData={resetData}
                       />
                    </div>

                    <div className='mar-auto-bg-white'>
                       <GstSorting
                       sorting={sorting}
                       setSorting={setSorting}
                       setOffset={setOffset}
                       resetData={resetData}
                       />
                    </div> 

                    <div>
                    <DownloadGstrReports
                    type="outwards"
                    clientCode={clientCode}
                    token={token}
                    companyName={companyName}
                    filters={filters}
                    sorting={sorting}
                    currentYear={currentYear}
                    text={text}
                    />
                    </div>
                </div>

            </div>
            {/* //comment for future use */}
            {/* <div style={{ backgroundColor: "#f4f6f8", height: '99px' }}>
                <div>
                    <div className='visual-summary'>
                        <div className='visual-summary-head'>Visual Summary</div>
                        <div className="visual-summary-hide">Hide</div>
                    </div>

                    <div className='pending-block'>
                        <div style={{ width: "45%", padding: "5px 0" }}>
                            <div>
                                <div>

                                    <div className='pending-block-two'>
                                        <div className='pending-block-two-1'>
                                            <div className='pending-invoice'>Pending Invoices to file GSTR1</div>
                                            <div className='pending-invoice' style={{ color: "#7c8db0" }}>Click on bar to see the list</div>
                                        </div>
                                        <div className='out-of'>100/150</div>
                                    </div>

                                </div>
                            </div>

                            <Progress style={{ height: "6px",backgroundColor:"#cce4e7" }} value={35}></Progress>
                        </div>
                        <div style={{ width: "45%", padding: "5px 0" }}>
                            <div>
                                <div>
                                    <div className='pending-block-two'>
                                        <div className='pending-block-two-1'>
                                            <div className='pending-invoice'>Pending Invoices to file GSTR1</div>
                                            <div className='pending-invoice' style={{ color: "#7c8db0" }}>Click on bar to see the list</div>
                                        </div>
                                        <div className='out-of'>100/150</div>
                                    </div>
                                </div>


                            </div>
                            <Progress color="info" style={{ height: "6px",backgroundColor:"#cce4e7" }} value={50} ></Progress>
                        </div>
                    </div>
                </div>
            </div> */}
        </>
    )
}

export default OutwardHeader